import React from 'react';
import A_Button from '@/components/A_Atoms/A_Button/A_Button';
import styles from './M_MyCapsuleCard.module.css';
import Q_MyCapsulePlaceholder from '@/components/Q_Quarks/Q_MyCapsulePlaceholder/Q_MyCapsulePlaceholder';
import W_CapsuleCreators from '@/components/W_Wrappers/W_CapsuleCreators/W_CapsuleCreators';
import cn from 'classnames';
import { formatDate } from '@/utils/formatters';
import type { ContentItem } from '@/services/capsulesApi';
import { getMediaUrl } from '@/utils/mediaUrl';

interface M_MyCapsuleCardProps {
  id?: string;
  content: ContentItem[];
  isActivated?: boolean;
  openedAt?: string;
  scheduledAt?: string;
  title?: string;
  avatars?: string[];
  coauthors?: number;
  ownerName?: string;
  isMyCapsule?: boolean;
  isLifeCapsule?: boolean;
  isGuardian?: boolean;
  onClick?: () => void;
  onActivate?: () => void;
  onPublish?: () => void;
}

export default function M_MyCapsuleCard({
  id,
  content,
  isActivated = false,
  openedAt,
  scheduledAt,
  title,
  avatars = [],
  coauthors = 0,
  ownerName,
  isMyCapsule = true,
  isLifeCapsule = false,
  isGuardian = false,
  onClick,
  onActivate,
  onPublish,
}: M_MyCapsuleCardProps) {
  const previewContent =
    isGuardian && isLifeCapsule
      ? [null, null, null]
      : (content || []).slice(0, 3);

  const renderContentBlock = (item: ContentItem | null, index: number) => {
    if (!item) {
      return (
        <div key={`empty-${index}`} className={styles.content_block}>
          <Q_MyCapsulePlaceholder type='empty' />
        </div>
      );
    }

    if (item.type === 'image') {
      return (
        <div key={item.id} className={styles.content_block}>
          <img
            src={getMediaUrl(item.url)}
            alt={item.caption || ''}
            className={styles.image}
          />
        </div>
      );
    } else {
      return (
        <div key={item.id} className={styles.content_block}>
          <Q_MyCapsulePlaceholder type={item.type} />
        </div>
      );
    }
  };

  const displayDate = isActivated && openedAt ? openedAt : scheduledAt;
  const hasDate = Boolean(displayDate);

  return (
    <div
      className={cn(styles.wrapper, { [styles.clickable]: !!onClick })}
      onClick={onClick}
    >
      <div className={styles.image_wrapper}>
        {renderContentBlock(previewContent[0] || null, 0)}
        {renderContentBlock(previewContent[1] || null, 1)}
        {renderContentBlock(previewContent[2] || null, 2)}
      </div>
      <div className={styles.content_wrapper}>
        <h4 className={styles.title}>
          {title || content[0]?.title || 'Без названия'}
        </h4>
        <div className={styles.action_wrapper}>
          <W_CapsuleCreators
            avatars={avatars}
            coauthors={coauthors}
            isMyCapsule={isMyCapsule}
            ownerName={ownerName}
          />
          {hasDate ? (
            <div className={cn(styles.opened_date, 'text-p-4')}>
              {formatDate(displayDate!)}
            </div>
          ) : isGuardian && isLifeCapsule ? (
            <A_Button
              variant='tertiary'
              size='small'
              fontSize='text-p-4'
              onClick={(e?: React.MouseEvent<HTMLButtonElement>) => {
                e?.stopPropagation();
                onPublish?.();
              }}
            >
              Опубликовать
            </A_Button>
          ) : !isLifeCapsule ? (
            <A_Button
              variant='tertiary'
              size='small'
              fontSize='text-p-4'
              onClick={(e?: React.MouseEvent<HTMLButtonElement>) => {
                e?.stopPropagation();
                onActivate?.();
              }}
            >
              Активировать
            </A_Button>
          ) : null}
        </div>
      </div>
    </div>
  );
}
